import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { useTaskManager } from "./useTaskManager";
import { AddTaskForm } from "./addTaskForm";

export const AddTaskDialog = ({
  open,
  onClose,
  ordname,
  doerName,
  onTaskAdded,
  setOrders,
  data,
}) => {
  // const [updateTasks, setUpdateTasks] = useState(data);
  const [updateTasks, setUpdateTasks] = useState(
    Array.isArray(data) ? data : []
  );

  const { newTask, setNewTask, loading, error, addTask, resetTask } =
    useTaskManager();

  const handleAddTask = async () => {
    console.log("handleAddTask");

    const task = await addTask(ordname, doerName, (newTask) => {
      // Update local state
      setUpdateTasks((prevTasks) => [...prevTasks, newTask]);

      // Update parent state
      setOrders((prev) => {
        return prev.map((order) => {
          if (order.ORDNAME === ordname) {
            return {
              ...order,
              GENCUSTNOTES_SUBFORM: [...order.GENCUSTNOTES_SUBFORM, newTask],
            };
          }
          return order;
        });
      });
      onTaskAdded(newTask);
    });
  };

  const handleClose = () => {
    resetTask();
    onClose();
  };

  return (
    <>
      {error}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        dir="rtl"
      >
        <DialogTitle>הוספת משימה חדשה</DialogTitle>
        <DialogContent>
          <AddTaskForm
            newTask={newTask}
            setNewTask={setNewTask}
            onCancel={handleClose}
            onSubmit={handleAddTask}
            loading={loading}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
